import React, { useState } from "react";
import { Button, Input, FormGroup, Label } from "reactstrap";

import Loading from "../components/Loading";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";

export const ProfileComponent = ({user, setUser}) => {
  const [wallet, setWallet] = useState(user.wallet);
  const [name, setName] = useState(user.name);
  const [username, setUsername] = useState(user.username);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(false);
  const { getIdTokenClaims, user: auser } = useAuth0();

  const handleSave = () => {
    const newUser = {...user, name: name || user.name, username: username || user.username, wallet: wallet}; 
    setIsSaving(true);
    saveUser(newUser);
  };

  async function saveUser(newUser) {
    const token = await getIdTokenClaims();
    const userId = auser.sub.split('|')[1];
    const response = await fetch(`https://lyykjoe06k.execute-api.us-east-1.amazonaws.com/dev/api/user/${userId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token.__raw}`,
      },
      body: JSON.stringify(newUser),
    });
    try {
      const data = await response.json();
      if(data) {
        setIsSaving(false);
        setWallet(data.wallet);
        setName(data.name);
        setUsername(data.username);
        setUser(newUser);
      }
    } catch(e) {
      setIsSaving(false);
      setError(true);
    }
  }

  return (
    <div className="frame settings">      
      <FormGroup className="form-highlight">
        <Label>Wallet Address</Label>
        <Input disabled={isSaving} type="text" name="wallet" id="wallet" placeholder="ETH Wallet Address (ERC-20)" value={wallet} onChange={e => setWallet(e.target.value.trim())} />
      </FormGroup>
      <FormGroup>
        <Label>Your Name</Label>
        <Input disabled={isSaving} type="text" name="title" id="title" placeholder="Name" value={name} onChange={e => setName(e.target.value)} />
      </FormGroup>
      <FormGroup>
        <Label>Username</Label>
        <Input disabled={isSaving} type="text" name="url" id="Username" placeholder="Username" value={username} onChange={e => {setUsername(e.target.value);setError(false);}} />
        {error && <small className="error">Username taken or invalid, please try again.</small>}
      </FormGroup>
      <Button disabled={isSaving} className="btn-primary" style={{borderRadius: '10px', width: '100%'}} onClick={handleSave}>Save</Button>
    </div>
  );
};

export default withAuthenticationRequired(ProfileComponent, {
  onRedirecting: () => <Loading />,
});
